import { Box, Button, InputAdornment, SelectChangeEvent, Stack, Tab, Tabs, Typography, useMediaQuery, ToggleButtonGroup, ToggleButton, IconButton, OutlinedInput, InputLabel, FormControl } from '@mui/material'
import React, { Dispatch, FunctionComponent, SetStateAction, useContext, useEffect, useState, useCallback, useRef } from 'react'
import { UserNotificationsContext } from '../../../../context/user-notifications/user-notifications';
import moment, { Moment } from 'moment';
import { IBuildingType, ICountry, IEditLocation, IMeter, IMeterReading, IPostMeter, IPostMeterReading } from '../../../../shared/services/location/location.model'
import LocationService from '../../../../shared/services/location/location.service'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import UserDetailsService from '../../../../shared/services/user-details/user-details.service'
import { IUserDetails } from '../../../../shared/services/user-details/user-details.model'
import { CustomTabPanel } from '../../display-elements-components/custom-tab-panel'
import { a11yProps } from '../../../../shared/utils/misc-shared-utils'
import { FormTextInputDisplay } from '../../form-field-components/new-and-edit/form-text-input'
import { FormDateInputDisplay } from '../../form-field-components/new-and-edit/form-date-input'
import { FormSelectInputDisplay } from '../../form-field-components/new-and-edit/form-select-input'
import { FormRadioInputDisplay } from '../../form-field-components/new-and-edit/form-radio-input';
import { FormAutoCompleteInputDisplay } from '../../form-field-components/new-and-edit/form-autocomplete-input';
import { FormCheckBoxInputDisplay } from '../../form-field-components/new-and-edit/form-checkbox-input';
import { BuildingPeriod } from '../../../../shared/interfaces/billing-period';
import { LoadingPage } from '../../../pages/loading-page';
import { ReportPeriodContext } from '../../../../context/report-periods/report-periods';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ClosedReportPeriodMessage } from '../../miscellaneous-components/closed-report-period-message';
import { StartNewReportPeriodDialog } from '../../../dialogs/settings/report-period/start-new-report-period-dialog';
import { Emissions } from '../../emissons-components/overview/emissions';
import { IHeadCell } from '../../../../shared/interfaces/table-display.model';
import { NumericFormat } from 'react-number-format';
import { TableDisplay } from '../../miscellaneous-components/table-display';
import gaiaTheme from '../../../../root-components/theme';
import { MeterInputDialog } from '../../../dialogs/organisation/meter-input-dialog';
import { MeterReadingInputDialog } from '../../../dialogs/organisation/meter-reading-input-dialog';
import { AddressSelectionDialog } from '../../../dialogs/organisation/address-selection-dialog';
import { MeterPostcodeDialog } from '../../../dialogs/organisation/meter-postcode-dialog';
import { Add, Refresh, Search, Visibility } from '@mui/icons-material';
import { InformationBox } from '../../miscellaneous-components/information-box';
import { IconName } from '../../../../shared/interfaces/icon-picker.model';
import { BackButtonLink } from '../../display-elements-components/back-button-link';
import { useHasOpenReportPeriod } from '../../../../hooks/use-has-open-report-period';
import { useIsReportPeriodLocked } from '../../../../hooks/use-is-report-period-locked';
import { NotesPanel } from '../../notes-components/notes-panel';
import { useNotePeriodOptions } from '../../notes-components/use-note-period-options';
import { ScreenLabelsContext } from '../../../../context/screen-labels/screen-labels';
import { TableActionButtons } from '../../miscellaneous-components/table-action-buttons';
import { UserDetailsContext } from '../../../../context/user-details/user-details';
import { IContactSupplierDetails } from '../../../../shared/services/contact-supplier/contact-supplier.model';
import { IEnergySupplierTariff } from '../../../../shared/services/energy-supplier-tariff/energy-supplier-tariff.model';
import EnergySupplierTariffService from '../../../../shared/services/energy-supplier-tariff/energy-supplier-tariff.service';
import CustomFieldService from '../../../../shared/services/custom-field/custom-field.service';
import { ICustomField } from '../../../../shared/services/custom-field/custom-field.model';
import SubsidiaryService from '../../../../shared/services/subsidiary/subsidiary.service';
import { ISubsidiary } from '../../../../shared/services/subsidiary/subsidiary.model';
import { getSelectableSubsidiaries } from '../../../../shared/utils/subsidiary-utils';
import { useDirtyBaseline } from '../../../../hooks/use-dirty-baseline';
import { useUnsavedChangesWarning } from '../../../../hooks/use-unsaved-changes-warning';
import { getCategoryDisplayName } from '../../../../shared/utils/category-utils';

export const LocationEditForm: FunctionComponent<{
  submitHandler: React.Dispatch<React.SetStateAction<any>>,
  newLocation: IEditLocation,
  editField: string,
  setEditField: React.Dispatch<React.SetStateAction<any>>,
  setErrorMessage?: Dispatch<SetStateAction<string | undefined>>,
  setErrorCode?: Dispatch<SetStateAction<number | undefined>>,
  errorMessage?: string,
  locationActive?: boolean;
  errorCode?: number,
  contactSuppliers: IContactSupplierDetails[],
}> = ({
  submitHandler,
  newLocation,
  editField,
  setEditField,
  setErrorMessage,
  setErrorCode,
  errorMessage,
  locationActive,
  errorCode,
  contactSuppliers,
}) => {
    const [searchParams] = useSearchParams()
    const navigate = useNavigate()
    //Services
    const locationService = new LocationService();
    const userDetailsService = new UserDetailsService();
    const energySupplierTariffService = new EnergySupplierTariffService()
    const customFieldService = new CustomFieldService()
    const subsidiaryService = SubsidiaryService.getInstance()
    //Context
    const reportPeriodContext = useContext(ReportPeriodContext);
    const userNotificationsContext = useContext(UserNotificationsContext);
    const userDetailsContext = useContext(UserDetailsContext);
    const organisation = userDetailsContext.userDetails?.organisation
    const screenLabelsContext = useContext(ScreenLabelsContext)
    //State
    const [subsidiaries, setSubsidiaries] = useState<ISubsidiary[]>()
    const [customFields, setCustomFields] = useState<ICustomField[]>();
    const [buildingTypes, setBuildingTypes] = useState<IBuildingType[]>();
    const [countries, setCountries] = useState<ICountry[]>();
    const [energySupplierTariffs, setEnergySupplierTariffs] = useState<IEnergySupplierTariff[]>();
    const [electricitySupplierMode, setElectricitySupplierMode] = useState<'precreated' | 'own'>('precreated');
    const [value, setValue] = React.useState(0)
    const [users, setUsers] = React.useState<IUserDetails[]>([]);
    const [showUtilities, setShowUtilities] = useState(true)
    const [dialogOpen, setDialogOpen] = useState(false);
    const [isGaiaUser, setIsGaiaUser] = useState<boolean>(false);
    //Meters State
    const [meters, setMeters] = useState<IMeter[]>([]);
    const [isMetersLoading, setIsMetersLoading] = useState<boolean>(false);
    const [meterInputDialogOpen, setMeterInputDialogOpen] = useState(false);
    const [meterEditDialogOpen, setMeterEditDialogOpen] = useState(false);
    const [meterReadingInputDialogOpen, setMeterReadingInputDialogOpen] = useState(false);
    const [selectedMeterForEdit, setSelectedMeterForEdit] = useState<IMeter | null>(null);
    const [errorMessageMeter, setErrorMessageMeter] = useState<string | null>(null);
    //Meter Search State
    const [meterSearchDialogOpen, setMeterSearchDialogOpen] = useState(false);
    const [searchPostcode, setSearchPostcode] = useState('');
    const [addressSelectionDialogOpen, setAddressSelectionDialogOpen] = useState(false);
    const [searchResults, setSearchResults] = useState<any[]>([]);
    const [selectedAddressId, setSelectedAddressId] = useState('');
    //Meter Readings State
    const [selectedMeter, setSelectedMeter] = useState<IMeter | null>(null);
    const [meterReadings, setMeterReadings] = useState<IMeterReading[]>([]);
    const [isReadingsLoading, setIsReadingsLoading] = useState<boolean>(false);
    const [showMeterReadings, setShowMeterReadings] = useState<boolean>(false);
    const [selectedMeterReadingForEdit, setSelectedMeterReadingForEdit] = useState<IMeterReading | null>(null);
    const [errorMessageMeterReading, setErrorMessageMeterReading] = useState<string | null>(null);
    //Table State (used by legacy effects; emissions listing now handled by Emissions component)
    const [inputPage, setInputPage] = useState(0)
    const [perPage, setPerPage] = useState(10)
    const [orderBy, setOrderBy] = useState<string>()
    const [order, setOrder] = useState<'asc' | 'desc'>()
    const [change, setChange] = useState<number>(0)
    //Meters Table State
    const [metersSelected, setMetersSelected] = useState<string[]>([]);
    const [metersInputPage, setMetersInputPage] = useState(0);
    const [metersTotalRecords, setMetersTotalRecords] = useState(0)
    const [metersPerPage, setMetersPerPage] = useState(10)
    const [metersChange, setMetersChange] = useState<number>(0)
    const [metersOrderBy, setMetersOrderBy] = useState<string>()
    const [metersOrder, setMetersOrder] = useState<'asc' | 'desc'>()
    //Loading State
    const [hasComponentMounted, setHasComponentMounted] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [isDialogSubmitting, setIsDialogSubmitting] = useState<boolean>(false)
    //Hooks 
    const hasOpenReport = useHasOpenReportPeriod([
      reportPeriodContext.allReportPeriods,
      reportPeriodContext.lastSelectedOpenReportId,
      dialogOpen,
    ]);
    const isReportPeriodLocked = useIsReportPeriodLocked()
    const notePeriodOptions = useNotePeriodOptions()
    // The page is admin and analyst only; a data owner in scope could also write (the backend
    // checks scope), so the same three roles that write location data write its notes.
    const canWriteNotes = !!userDetailsContext.userDetails?.roles?.some((role) => role === 'admin' || role === 'analyst' || role === 'data-owner')
    //Variables
    const ownership: string[] = [
      'Leased', 'Owned (Using)', 'Owned (Leased Out)'
    ]
    //Layout
    const isMobileMode = useMediaQuery(gaiaTheme.breakpoints.down('sm'));
    //Formik
    const locationSchema = Yup.object().shape({
      friendlyName: Yup.string().required(`${screenLabelsContext.getLabel('location', { plural: false, capitalize: 'first' })} name is required`),
      buildingTypeId: Yup.string().required('Building type is required'),
      ownership: Yup.string().required('Ownership status is required'),
      locationReference: Yup.string().nullable(),
      hasOperationalControl: Yup.boolean().required('Control status is required'),
      floorSpaceOrganisation: Yup.number().min(0).nullable(),
      floorSpaceBuilding: Yup.number().min(0).nullable(),
      occupancyRate: Yup.number().min(0).max(100).nullable(),
      countryId: Yup.string().required('Country is required'),
      addressLineOne: Yup.string().nullable(),
      addressLineTwo: Yup.string().nullable(),
      city: Yup.string().nullable(),
      postcode: Yup.string().nullable(),
      numberOfEmployees: Yup.number().integer().nullable(),
      assignedUserId: Yup.string().nullable(),
      startDate: Yup.string().required(`You must provide a start date for the ${screenLabelsContext.getLabel('location', { plural: false })}`),
      endDate: Yup.string().nullable(),
      subsidiaryId: Yup.string().nullable(),
      hasGas: Yup.boolean(),
      hasSteam: Yup.boolean(),
      hasAirCon: Yup.boolean(),
      hasElectricity: Yup.boolean(),
      gasBillingPeriod: Yup.string().when('hasGas', {
        is: true,
        then: schema => schema.required('Frequency of data entry is required'),
        otherwise: schema => schema.notRequired()
      }),
      heatAndSteamBillingPeriod: Yup.string().when('hasSteam', {
        is: true,
        then: schema => schema.required('Frequency of data entry is required'),
        otherwise: schema => schema.notRequired()
      }),
      airConBillingPeriod: Yup.string().when('hasAirCon', {
        is: true,
        then: schema => schema.required('Frequency of data entry is required'),
        otherwise: schema => schema.notRequired()
      }),
      electricityBillingPeriod: Yup.string().when('hasElectricity', {
        is: true,
        then: schema => schema.required('Frequency of data entry is required'),
        otherwise: schema => schema.notRequired()
      }),
      hasWater: Yup.boolean(),
      hasWaste: Yup.boolean(),
      waterBillingPeriod: Yup.string().when('hasWater', {
        is: true,
        then: schema => schema.required('Frequency of data entry is required'),
        otherwise: schema => schema.notRequired()
      }),
      wasteBillingPeriod: Yup.string().when('hasWaste', {
        is: true,
        then: schema => schema.required('Frequency of data entry is required'),
        otherwise: schema => schema.notRequired()
      }),
      // isPrimaryLocation: Yup.boolean(),
      customMarketBasedMultiplier: Yup.number().nullable(),
      electricitySupplierId: Yup.string()
        .nullable()
        .test('electricitySupplier-mutually-exclusive', 'Select a supplier OR enter a new name, not both', function (value) {
          const { electricitySupplierName } = this.parent as any
          const hasId = typeof value === 'string' && value.trim().length > 0
          const hasName = typeof electricitySupplierName === 'string' && electricitySupplierName.trim().length > 0
          if (hasId && hasName) return false
          return true
        }),
      electricitySupplierName: Yup.string()
        .nullable()
        .test('electricitySupplierName-mutually-exclusive', 'Select a supplier OR enter a new name, not both', function (value) {
          const { electricitySupplierId } = this.parent as any
          const hasName = typeof value === 'string' && value.trim().length > 0
          const hasId = typeof electricitySupplierId === 'string' && electricitySupplierId.trim().length > 0
          if (hasId && hasName) return false
          return true
        }),
      gasSupplierName: Yup.string()
        .nullable()
        .test('gasSupplierName-mutually-exclusive', 'Select a supplier OR enter a new name, not both', function (value) {
          const { gasSupplierId } = this.parent as any
          const hasName = typeof value === 'string' && value.trim().length > 0
          const hasId = typeof gasSupplierId === 'string' && gasSupplierId.trim().length > 0
          if (hasId && hasName) return false
          return true
        }),
      heatAndSteamSupplierName: Yup.string()
        .nullable()
        .test('heatAndSteamSupplierName-mutually-exclusive', 'Select a supplier OR enter a new name, not both', function (value) {
          const { heatAndSteamSupplierId } = this.parent as any
          const hasName = typeof value === 'string' && value.trim().length > 0
          const hasId = typeof heatAndSteamSupplierId === 'string' && heatAndSteamSupplierId.trim().length > 0
          if (hasId && hasName) return false
          return true
        }),
      heatAndSteamSupplierId: Yup.string()
        .nullable()
        .test('heatAndSteamSupplier-mutually-exclusive', 'Select a supplier OR enter a new name, not both', function (value) {
          const { heatAndSteamSupplierName } = this.parent as any
          const hasId = typeof value === 'string' && value.trim().length > 0
          const hasName = typeof heatAndSteamSupplierName === 'string' && heatAndSteamSupplierName.trim().length > 0
          if (hasId && hasName) return false
          return true
        }),
      gasSupplierId: Yup.string()
        .nullable()
        .test('gasSupplier-mutually-exclusive', 'Select a supplier OR enter a new name, not both', function (value) {
          const { gasSupplierName } = this.parent as any
          const hasId = typeof value === 'string' && value.trim().length > 0
          const hasName = typeof gasSupplierName === 'string' && gasSupplierName.trim().length > 0
          if (hasId && hasName) return false
          return true
        }),
      airConSupplierName: Yup.string()
        .nullable()
        .test('airConSupplierName-mutually-exclusive', 'Select a supplier OR enter a new name, not both', function (value) {
          const { airConSupplierId } = this.parent as any
          const hasName = typeof value === 'string' && value.trim().length > 0
          const hasId = typeof airConSupplierId === 'string' && airConSupplierId.trim().length > 0
          if (hasId && hasName) return false
          return true
        }),
      airConSupplierId: Yup.string()
        .nullable()
        .test('airConSupplier-mutually-exclusive', 'Select a supplier OR enter a new name, not both', function (value) {
          const { airConSupplierName } = this.parent as any
          const hasId = typeof value === 'string' && value.trim().length > 0
          const hasName = typeof airConSupplierName === 'string' && airConSupplierName.trim().length > 0
          if (hasId && hasName) return false
          return true
        }),
      energySupplierTariffId: Yup.string().nullable(),
      ...(customFields && customFields.length > 0 ? customFields.reduce((acc, field) => {
        if (field.isMandatory) {
          acc[field.id] = Yup.string().required(`${field.fieldName} is mandatory`);
        } else {
          acc[field.id] = Yup.string().nullable();
        }
        return acc;
      }, {} as any) : {}),
    })

    const getInitialCustomFieldValues = useCallback(() => {
      if (!customFields || !customFields.length) return {};

      return customFields.reduce((acc, field) => {
        const matchingValue = 'customFieldValues' in newLocation && newLocation.customFieldValues
          ? newLocation.customFieldValues.find(v => v.customFieldId === field.id)?.value ?? ''
          : '';
        acc[field.id] = matchingValue;
        return acc;
      }, {} as Record<string, any>);
    }, [customFields, newLocation]);

    const formik = useFormik<any>({
      initialValues: {
        friendlyName: newLocation.friendlyName,
        buildingTypeId: newLocation.buildingTypeId,
        countryId: newLocation.countryId,
        addressLineOne: newLocation.addressLineOne,
        addressLineTwo: newLocation.addressLineTwo,
        city: newLocation.city,
        postcode: newLocation.postcode,
        numberOfEmployees: newLocation.numberOfEmployees,
        startDate: newLocation.startDate,
        endDate: newLocation.endDate,
        hasGas: newLocation.hasGas,
        hasSteam: newLocation.hasSteam,
        hasAirCon: newLocation.hasAirCon,
        hasElectricity: newLocation.hasElectricity,
        gasBillingPeriod: newLocation.gasBillingPeriod,
        heatAndSteamBillingPeriod: newLocation.heatAndSteamBillingPeriod,
        airConBillingPeriod: newLocation.airConBillingPeriod,
        electricityBillingPeriod: newLocation.electricityBillingPeriod,
        hasWater: newLocation.hasWater,
        waterBillingPeriod: newLocation.waterBillingPeriod,
        hasWaste: newLocation.hasWaste,
        wasteBillingPeriod: newLocation.wasteBillingPeriod,
        energySupplierTariffId: newLocation.energySupplierTariffId,
        // isPrimaryLocation: newLocation.isPrimaryLocation,
        ownership: newLocation.ownership,
        hasOperationalControl: newLocation.hasOperationalControl,
        floorSpaceOrganisation: newLocation.floorSpaceOrganisation,
        floorSpaceBuilding: newLocation.floorSpaceBuilding,
        occupancyRate: newLocation.occupancyRate != null ? newLocation.occupancyRate * 100 : newLocation.occupancyRate,
        assignedUserId: newLocation.assignedUserId,
        customMarketBasedMultiplier: newLocation.customMarketBasedMultiplier,
        locationReference: newLocation.locationReference ? newLocation.locationReference.split(',').join(', ') : null,
        electricitySupplierId: newLocation.electricitySupplierId,
        gasSupplierId: newLocation.gasSupplierId,
        heatAndSteamSupplierId: newLocation.heatAndSteamSupplierId,
        airConSupplierId: newLocation.airConSupplierId,
        subsidiaryId: newLocation.subsidiaryId,
        ...getInitialCustomFieldValues(),
      },
      validationSchema: locationSchema,
      onSubmit: (values) => {
        const formattedValues = {
          ...values,
          floorSpaceOrganisation: values.floorSpaceOrganisation === "" ? null : values.floorSpaceOrganisation,
          floorSpaceBuilding: values.floorSpaceBuilding === "" ? null : values.floorSpaceBuilding,
          occupancyRate: values.occupancyRate === "" ? null : values.occupancyRate,
          numberOfEmployees: values.numberOfEmployees === "" ? null : values.numberOfEmployees,
          energySupplierTariffId: values.energySupplierTariffId === "" ? null : values.energySupplierTariffId,
          electricitySupplierId: values.electricitySupplierId === "" ? null : values.electricitySupplierId,
          gasSupplierId: values.gasSupplierId === "" ? null : values.gasSupplierId,
          heatAndSteamSupplierId: values.heatAndSteamSupplierId === "" ? null : values.heatAndSteamSupplierId,
          airConSupplierId: values.airConSupplierId === "" ? null : values.airConSupplierId,
          subsidiaryId: values.subsidiaryId === "" ? null : values.subsidiaryId,
        };
        const customFieldValues = Array.isArray(customFields)
          ? customFields.map((field) => ({
            customFieldId: field.id,
            value: values?.[field.id] ?? null,
          }))
          : []
        submitHandler({
          ...formattedValues,
          customFieldValues,
        });
      }
    });

    const formikRef = useRef(formik);
    formikRef.current = formik;

    // Warn before the browser unloads while the form holds unsaved edits. formik.dirty is
    // unusable here (the form is re-seeded via setValues whenever a fresh location
    // arrives), so track dirtiness against a baseline. The baseline snapshot is taken
    // inside the seeding effect below, so it only ever happens when the form really was
    // rewritten from server state: display, values and baseline always agree.
    const { isDirty, rebaseline } = useDirtyBaseline(formik.values)
    useUnsavedChangesWarning(isDirty)

    // Occupied floor area = building floor area × share of building occupied (the % field / 100).
    // When both inputs are present it is derived + read-only, matching the server-side derivation,
    // so the stored occupied area and its inputs can't disagree (GHG-Protocol apportionment).
    const buildingFloorArea = formik.values.floorSpaceBuilding
    const shareOccupiedPct = formik.values.occupancyRate
    const isOccupiedFloorAreaDerived =
      buildingFloorArea !== '' && buildingFloorArea != null &&
      shareOccupiedPct !== '' && shareOccupiedPct != null
    useEffect(() => {
      if (isOccupiedFloorAreaDerived) {
        // Round to 2dp to match the backend derivation and avoid float noise in the read-only field.
        const derived = Math.round(Number(buildingFloorArea) * (Number(shareOccupiedPct) / 100) * 100) / 100
        if (Number(formik.values.floorSpaceOrganisation) !== derived) {
          formik.setFieldValue('floorSpaceOrganisation', derived)
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [buildingFloorArea, shareOccupiedPct])

    const makeSupplierChangeHandler = (prefix: 'electricity' | 'gas' | 'heatAndSteam' | 'airCon') => (_event: any, newValue: any) => {
      const idField = `${prefix}SupplierId`;
      const nameField = `${prefix}SupplierName`;
      if (newValue && typeof newValue === 'object' && 'id' in newValue) {
        formik.setFieldValue(idField, (newValue as IContactSupplierDetails).id);
        formik.setFieldValue(nameField, '');
      } else if (typeof newValue === 'string') {
        formik.setFieldValue(idField, '');
        formik.setFieldValue(nameField, newValue);
      } else {
        formik.setFieldValue(idField, '');
        formik.setFieldValue(nameField, '');
      }
    };

    const makeSupplierInputChangeHandler = (prefix: 'electricity' | 'gas' | 'heatAndSteam' | 'airCon') => (_event: any, newInputValue: string) => {
      const idField = `${prefix}SupplierId`;
      const nameField = `${prefix}SupplierName`;
      formik.setFieldValue(idField, '');
      formik.setFieldValue(nameField, newInputValue || '');
    };
    //Use Effects
    useEffect(() => {
      if (userDetailsContext.userDetails?.email.indexOf('@gaiacompany.io') !== -1) {
        setIsGaiaUser(true);
      }

      subsidiaryService.getAll()
        .then(response => {
          setSubsidiaries(response)
        })
        .catch(err => console.log(err))
    }, [])

    // Follow the tabId query param whenever it changes, not only on first mount, so navigating
    // to "?tabId=4" from elsewhere on this page (e.g. after a floor-area estimate) switches tab.
    useEffect(() => {
      const token = searchParams.get('tabId')
      if (token !== null) {
        setValue(parseInt(token))
      }
    }, [searchParams])

    useEffect(() => {
      if (hasComponentMounted) {
        if (inputPage === 0) {
          setChange(change + 1)
        } else {
          setInputPage(0)
        }
      }
      setHasComponentMounted(true)
    }, [value, reportPeriodContext.lastSelectedReportId, order, orderBy])

    useEffect(() => {
      if (!showUtilities) {
        formikRef.current.setFieldValue('hasAirCon', false)
        formikRef.current.setFieldValue('hasElectricity', false)
        formikRef.current.setFieldValue('hasGas', false)
        formikRef.current.setFieldValue('hasSteam', false)
        formikRef.current.setFieldValue('hasWater', false)
        formikRef.current.setFieldValue('hasWaste', false)
        formikRef.current.setFieldValue('customMarketBasedMultiplier', null)
        // Programmatic zeroing (mount, tab change, operational control off) must not
        // leave an untouched page dirty: baseline exactly the fields written here. When
        // the trigger was a user edit, its own driver field keeps the form dirty.
        rebaseline(['hasAirCon', 'hasElectricity', 'hasGas', 'hasSteam', 'hasWater', 'hasWaste', 'customMarketBasedMultiplier'])
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showUtilities])

    // Re-seed the whole form whenever a fresh location arrives (mount, custom fields
    // loading, a successful save, or a parent-triggered refetch such as deactivate or a
    // floor-area estimate). This runs for orgs without custom fields too, so the refetch
    // path can never leave the display, the values and the dirty baseline disagreeing.
    useEffect(() => {
      if (newLocation) {
        const customFieldValues = getInitialCustomFieldValues();

        formikRef.current.setValues({
          friendlyName: newLocation.friendlyName,
          buildingTypeId: newLocation.buildingTypeId,
          countryId: newLocation.countryId,
          addressLineOne: newLocation.addressLineOne,
          addressLineTwo: newLocation.addressLineTwo,
          city: newLocation.city,
          postcode: newLocation.postcode,
          numberOfEmployees: newLocation.numberOfEmployees,
          startDate: newLocation.startDate,
          endDate: newLocation.endDate,
          hasGas: newLocation.hasGas,
          hasSteam: newLocation.hasSteam,
          hasAirCon: newLocation.hasAirCon,
          hasElectricity: newLocation.hasElectricity,
          gasBillingPeriod: newLocation.gasBillingPeriod,
          heatAndSteamBillingPeriod: newLocation.heatAndSteamBillingPeriod,
          airConBillingPeriod: newLocation.airConBillingPeriod,
          electricityBillingPeriod: newLocation.electricityBillingPeriod,
          hasWater: newLocation.hasWater,
          waterBillingPeriod: newLocation.waterBillingPeriod,
          hasWaste: newLocation.hasWaste,
          wasteBillingPeriod: newLocation.wasteBillingPeriod,
          // isPrimaryLocation: newLocation.isPrimaryLocation,
          ownership: newLocation.ownership,
          hasOperationalControl: newLocation.hasOperationalControl,
          floorSpaceOrganisation: newLocation.floorSpaceOrganisation,
          floorSpaceBuilding: newLocation.floorSpaceBuilding,
          occupancyRate: newLocation.occupancyRate != null ? newLocation.occupancyRate * 100 : newLocation.occupancyRate,
          assignedUserId: newLocation.assignedUserId,
          customMarketBasedMultiplier: newLocation.customMarketBasedMultiplier,
          locationReference: newLocation.locationReference ? newLocation.locationReference.split(',').join(', ') : null,
          electricitySupplierId: newLocation.electricitySupplierId,
          gasSupplierId: newLocation.gasSupplierId,
          heatAndSteamSupplierId: newLocation.heatAndSteamSupplierId,
          airConSupplierId: newLocation.airConSupplierId,
          energySupplierTariffId: newLocation.energySupplierTariffId,
          subsidiaryId: newLocation.subsidiaryId,
          ...customFieldValues,
        });
        // Full snapshot is safe here: the setValues above rewrites every field the form
        // has, so the baseline always matches exactly what the form now shows.
        rebaseline()
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customFields, newLocation, getInitialCustomFieldValues])

    useEffect(() => {
      if (!newLocation.hasOperationalControl) {
        setShowUtilities(false)
      }
      if (value === 0) {
        userDetailsService.getAllUserDetails(`?status=active`)
          .then((response) => {
            setUsers(response.filter(user => !(user.inviteSent === true && user.inviteAccepted === false)))
          })
          .catch(err => {
            console.log(err)
          })
        locationService.getAllCountries()
          .then(response => {
            setCountries(response)
          })
          .catch(err => {
            console.log(err)
          })
      }
      if (value === 0) {
        customFieldService.getAllActive(`&entryType=location`)
          .then(response => {
            setCustomFields(response)
          })
          .catch(err => {
            console.log(err)
          })
      }
      if (value === 1) {
        locationService.getAllBuildingType()
          .then(response => {
            setBuildingTypes(response)
          })
          .catch(err => {
            console.log(err)
          })
      }
      if (value === 2) {
        energySupplierTariffService.getAllActive()
          .then(response => {
            setEnergySupplierTariffs(response)
          })
          .catch(err => {
            console.log(err)
          })
      }
    }, [value])

    useEffect(() => {
      if (value === 3) {
        getMeters()
      }
    }, [metersInputPage, metersPerPage, metersChange, metersOrderBy, metersOrder, value])

    useEffect(() => {
      if (value === 4) {
        getTransactions()
      }
    }, [reportPeriodContext.lastSelectedReportId, inputPage, perPage, change])


    const getMeters = () => {
      setIsMetersLoading(true)
      return locationService.getMetersByLocationId(newLocation.id, metersInputPage, metersPerPage, metersOrderBy, metersOrder)
        .then(response => {
          let metersData: IMeter[] = [];
          if (response && response.rows && Array.isArray(response.rows)) {
            metersData = response.rows;
            setMeters(response.rows)
            setMetersTotalRecords(response.count || response.rows.length)
          } else if (Array.isArray(response)) {
            metersData = response;
            setMeters(response)
            setMetersTotalRecords(response.length)
          } else {
            setMeters([])
            setMetersTotalRecords(0)
          }
          setIsMetersLoading(false)
          return metersData;
        })
        .catch(err => {
          console.log(err)
          setIsMetersLoading(false)
          setMeters([])
          setMetersTotalRecords(0)
          return [];
        })
    }

    const getMeterReadings = (meterId: string) => {
      setIsReadingsLoading(true)
      locationService.getMeterReadings(meterId)
        .then(response => {
          setMeterReadings(response)
          setIsReadingsLoading(false)
        })
        .catch(err => {
          console.log(err)
          setIsReadingsLoading(false)
          setMeterReadings([])
        })
    }

    const getTransactions = () => {
      if (reportPeriodContext.lastSelectedReportId) {
        setIsLoading(false)
      }
    }

    const changeTabHandler = (event: React.SyntheticEvent, newValue: number) => {
      setValue(newValue);
      cancelEditHandler();
      if (newValue === 2) {
        const hasPrecreatedTariff = !!formik.values.energySupplierTariffId;
        const hasActiveMarketBasedConversion = Array.isArray(newLocation.locationMarketBasedConversions)
          ? newLocation.locationMarketBasedConversions.some(c => c.isActive)
          : false;
        const hasCustomRate = typeof formik.values.customMarketBasedMultiplier === 'number' && !Number.isNaN(formik.values.customMarketBasedMultiplier);
        if (hasPrecreatedTariff) {
          setElectricitySupplierMode('precreated');
        } else if (hasActiveMarketBasedConversion || hasCustomRate) {
          setElectricitySupplierMode('own');
        } else {
          setElectricitySupplierMode('precreated');
        }
      }
      if (newValue !== 3) {
        setShowMeterReadings(false);
        setSelectedMeter(null);
        setMeterReadings([]);
        setMetersSelected([]);
      }
    };

    const cancelEditHandler = () => {
      if (setEditField) {
        setEditField('')
      }
      formik.setTouched({})
      formik.setErrors({})
      if (setErrorMessage) {
        setErrorMessage(undefined)
      }
      if (setErrorCode) {
        setErrorCode(undefined)
      }
      formik.setFieldValue('endDate', null)
      if (newLocation) {
        const originalCustomFieldValues = customFields?.reduce((acc, field) => {
          const originalValue = 'customFieldValues' in newLocation && newLocation.customFieldValues
            ? newLocation.customFieldValues.find(v => v.customFieldId === field.id)?.value ?? ''
            : '';
          acc[field.id] = originalValue;
          return acc;
        }, {} as Record<string, any>) || {};


        formik.setValues({
          friendlyName: newLocation.friendlyName,
          buildingTypeId: newLocation.buildingTypeId,
          countryId: newLocation.countryId,
          addressLineOne: newLocation.addressLineOne,
          addressLineTwo: newLocation.addressLineTwo,
          city: newLocation.city,
          postcode: newLocation.postcode,
          numberOfEmployees: newLocation.numberOfEmployees,
          startDate: newLocation.startDate,
          endDate: newLocation.endDate,
          hasGas: newLocation.hasGas,
          hasSteam: newLocation.hasSteam,
          hasAirCon: newLocation.hasAirCon,
          hasElectricity: newLocation.hasElectricity,
          gasBillingPeriod: newLocation.gasBillingPeriod,
          heatAndSteamBillingPeriod: newLocation.heatAndSteamBillingPeriod,
          airConBillingPeriod: newLocation.airConBillingPeriod,
          electricityBillingPeriod: newLocation.electricityBillingPeriod,
          hasWater: newLocation.hasWater,
          waterBillingPeriod: newLocation.waterBillingPeriod,
          hasWaste: newLocation.hasWaste,
          wasteBillingPeriod: newLocation.wasteBillingPeriod,
          energySupplierTariffId: newLocation.energySupplierTariffId,
          ownership: newLocation.ownership,
          hasOperationalControl: newLocation.hasOperationalControl,
          floorSpaceOrganisation: newLocation.floorSpaceOrganisation,
          // isPrimaryLocation: newLocation.isPrimaryLocation,
          assignedUserId: newLocation.assignedUserId,
          floorSpaceBuilding: newLocation.floorSpaceBuilding,
          occupancyRate: newLocation.occupancyRate != null ? newLocation.occupancyRate * 100 : newLocation.occupancyRate,
          customMarketBasedMultiplier: newLocation.customMarketBasedMultiplier,
          locationReference: newLocation.locationReference ? newLocation.locationReference.split(',').join(', ') : null,
          electricitySupplierId: newLocation.electricitySupplierId,
          gasSupplierId: newLocation.gasSupplierId,
          heatAndSteamSupplierId: newLocation.heatAndSteamSupplierId,
          airConSupplierId: newLocation.airConSupplierId,
          subsidiaryId: newLocation.subsidiaryId,
          ...originalCustomFieldValues,
        })
        if (value === 2) {
          const hasPrecreatedTariff = !!newLocation.energySupplierTariffId;
          const hasActiveMarketBasedConversion = Array.isArray(newLocation.locationMarketBasedConversions)
            ? newLocation.locationMarketBasedConversions.some(c => c.isActive)
            : false;
          const hasCustomRate = typeof newLocation.customMarketBasedMultiplier === 'number' && !Number.isNaN(newLocation.customMarketBasedMultiplier as any);
          if (hasPrecreatedTariff) {
            setElectricitySupplierMode('precreated');
          } else if (hasActiveMarketBasedConversion || hasCustomRate) {
            setElectricitySupplierMode('own');
          } else {
            setElectricitySupplierMode('precreated');
          }
        }
      }
    }

    const selectCountryHandler = (e: SelectChangeEvent<ICountry | null>, value: ICountry | null) => {
      if (value) {
        formik.setValues({ ...formik.values, countryId: value.id })
      }
    }

    const dateHandler = (date: Moment | null, name: string) => {
      if (date) {
        formik.setValues({ ...formik.values, [name]: date.format('YYYY-MM-DD') })
      }
    }

    const checkboxHandler = (e: React.ChangeEvent<HTMLInputElement>, name: string) => {
      const { checked } = e.target;
      const nextValues: any = { ...formik.values, [name]: checked };
      if (name === 'hasElectricity' && checked === false) {
        nextValues.electricitySupplierId = '';
        nextValues.electricitySupplierName = '';
        nextValues.electricityBillingPeriod = '';
        nextValues.customMarketBasedMultiplier = null;
        nextValues.energySupplierTariffId = '';
      }
      formik.setValues(nextValues)
    }

    const handleElectricitySupplierModeChange = (_e: any, val: 'precreated' | 'own' | null) => {
      if (!val) return;
      setElectricitySupplierMode(val);
      if (val === 'own') {
        formik.setFieldValue('energySupplierTariffId', '');
        if (editField === 'energySupplierTariffId') {
          setEditField && setEditField('customMarketBasedMultiplier');
        }
      }
      if (val === 'precreated') {
        formik.setFieldValue('customMarketBasedMultiplier', null);
        if (editField === 'customMarketBasedMultiplier') {
          setEditField && setEditField('energySupplierTariffId');
        }
      }
    }

    const handlePreCreatedTariffChange = (tariffId: string) => {
      formik.setFieldValue('energySupplierTariffId', tariffId);
    }

    const controlStatusHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value === 'true';
      formik.setFieldValue('hasOperationalControl', value)
      if (value === true) {
        setShowUtilities(true)
      }
      if (value === false) {
        setShowUtilities(false)
      }
    }

    // Meters Table 
    const metersHeadCells: IHeadCell[] = [
      { id: 'action', numeric: false, label: 'Action', sortable: false },
      { id: 'name', numeric: false, label: 'Meter Name', sortable: true, isHeading: true },
      { id: 'conversion', numeric: false, label: 'Conversion', sortable: false },
      { id: 'lastReadingDate', numeric: false, label: 'Last Reading Date', sortable: true },
    ];

    const metersRows = (meters || []).map(meter => {
      return {
        id: meter.id,
        name: meter.name,
        conversion: meter.conversion ?
          `${getCategoryDisplayName(meter.conversion.category)}, ${meter.conversion.detailLevelOne}, ${meter.conversion.detailLevelTwo}${meter.conversion.detailLevelThree ? `, ${meter.conversion.detailLevelThree}` : ''}${meter.conversion.detailLevelFour ? `, ${meter.conversion.detailLevelFour}` : ''}${meter.conversion.detailLevelFive ? `, ${meter.conversion.detailLevelFive}` : ''}, ${meter.conversion.measurementUnit?.name}`
          : '',
        lastReadingDate: meter.lastReadingDate ? moment(meter.lastReadingDate).format('DD/MM/YYYY') : 'No Readings',
        action: (
          <TableActionButtons
            id={meter.id.toString()}
            includeEdit={true}
            includeView={true}
            onEdit={(id: string) => handleEditMeter(meter)}
            onView={(id: string) => handleMeterClick(meter)}
            disableButton={!locationActive}
          />
        ),
      }
    });

    const handleMetersOrderChange = (orderBy: string, order: 'asc' | 'desc',) => {
      setMetersOrderBy(orderBy)
      setMetersOrder(order)
    };

    const handleMetersSelected = (selectedRowId: string[]) => {
      if (selectedRowId[0] !== undefined) {
        const selectedMeter = meters.find(meter => meter.id.toString() === selectedRowId[0])
        if (selectedMeter) {
          setSelectedMeter(selectedMeter)
          getMeterReadings(selectedMeter.id)
          setShowMeterReadings(true)
        }
      }
    }

    const handleEditMeter = (meter: IMeter) => {
      setSelectedMeterForEdit(meter);
      setMeterEditDialogOpen(true);
    };

    const handleMeterClick = (meter: IMeter) => {
      setSelectedMeter(meter)
      getMeterReadings(meter.id)
      setShowMeterReadings(true)
    }

    const handleSearchMeter = () => {
      if (newLocation.postcode) {
        performMeterSearch(newLocation.postcode);
      } else {
        setMeterSearchDialogOpen(true);
      }
    };

    const handleSearchMeterWithPostcode = () => {
      if (searchPostcode.trim()) {
        performMeterSearch(searchPostcode.trim());
        setMeterSearchDialogOpen(false);
        setSearchPostcode('');
      }
    };

    const performMeterSearch = (postcode: string) => {
      locationService.searchMeterByPostcode(postcode)
        .then(response => {
          if (response && Array.isArray(response) && response.length > 0) {
            setSearchResults(response);
            setAddressSelectionDialogOpen(true);
            userNotificationsContext.openSnackbar({
              open: true,
              message: `Found ${response.length} address(es)`
            });
          } else {
            userNotificationsContext.openSnackbar({
              open: true,
              message: 'No addresses found',
              backgroundColor: 'text.primary'
            });
          }
        })
        .catch(err => {
          console.error('Meter search error:', err);
          userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
        });
    };

    const handleAddressSelection = (subsidiaryId?: string, fuelType?: string) => {
      if (selectedAddressId) {
        const finalSubsidiaryId = subsidiaryId || newLocation.subsidiaryId;
        const finalFuelType = fuelType || 'elec';
        locationService.getMeterDetailsByAddressId(
          selectedAddressId,
          newLocation.id,
          finalSubsidiaryId,
          finalFuelType,
          'yes', // customerConsent
        )
          .then(response => {
            if (response.createdMeterId) {
              setAddressSelectionDialogOpen(false);
              setSelectedAddressId('');
              setSearchResults([]);
              getMeters()
              // .then((updatedMeters) => {
              //   const newMeter = updatedMeters.find(meter => meter.id === response.createdMeterId);

              //   if (newMeter) {
              //     handleMeterClick(newMeter);
              //   } else {
              //     // If meter not found, try one more time with a small delay
              //     setTimeout(() => {
              //       getMeters().then((retryMeters) => {
              //         const retryMeter = retryMeters.find(meter => meter.id === response.createdMeterId);
              //         if (retryMeter) {
              //           handleMeterClick(retryMeter);
              //         }
              //       });
              //     }, 1000);
              //   }
              // });
              userNotificationsContext.openSnackbar({ open: true, message: `Updated successfully` });
            } else {
              // I dont understand what this else is ?? 
              userNotificationsContext.openSnackbar({
                open: true,
                message: 'Meter details retrieved. Check console for results.'
              });
              setAddressSelectionDialogOpen(false);
              setSelectedAddressId('');
              setSearchResults([]);
            }
          })
          .catch(err => {
            console.error('Meter details error:', err);
            userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
          });
      }
    };

    const submitMeterHandler = (values: IPostMeter, resetForm: () => void, isEdit: boolean) => {
      if (!isEdit) {
        if (!isDialogSubmitting) {
          setIsDialogSubmitting(true)
          locationService.createMeter(values)
            .then(() => {
              setMetersChange(metersChange + 1);
              setSelectedMeter(null);
              setMeterReadings([]);
              setShowMeterReadings(false);
              setMetersSelected([]);
              resetForm();
              setIsDialogSubmitting(false)
              userNotificationsContext.openSnackbar({ open: true, message: `Saved successfully` });
              setMeterInputDialogOpen(false);
            })
            .catch(err => {
              if (err.response.data.message) {
                setErrorMessageMeter(err.response.data.message)
              } else {
                userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
              }
              console.log(err)
              setIsDialogSubmitting(false)
            })
        }
      }
      if (isEdit && selectedMeterForEdit) {
        if (!isDialogSubmitting) {
          setIsDialogSubmitting(true)
          locationService.updateMeter(selectedMeterForEdit.id, values)
            .then(response => {
              setMetersChange(metersChange + 1);
              if (selectedMeter && selectedMeter.id === response.id) {
                setSelectedMeter(response);
              }
              resetForm();
              setSelectedMeterForEdit(null)
              userNotificationsContext.openSnackbar({ open: true, message: `Updated successfully` });
              setIsDialogSubmitting(false)
            })
            .catch(err => {
              if (err.response.data.message) {
                setErrorMessageMeter(err.response.data.message)
              } else {
                userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
              }
              console.log(err)
              setIsDialogSubmitting(false)
            })
        }
      }
    }

    const handleBackToMeters = () => {
      setShowMeterReadings(false)
      setSelectedMeter(null)
      setMeterReadings([])
      setMetersSelected([])
    }

    const handleCloseMeterInputDialog = () => {
      setMeterInputDialogOpen(false);
    };

    // Meter Readings Table 
    const readingsHeadCells: IHeadCell[] = [
      { id: 'readingDate', numeric: false, label: 'Reading Date', sortable: false, isHeading: true },
      { id: 'readingAmount', numeric: true, label: 'Reading Amount', sortable: false },
      // { id: 'emission', numeric: false, label: 'Meter Emission', sortable: false },
    ];

    const readingsRows = (meterReadings || []).map((reading, index) => {
      return {
        id: reading.id || index.toString(),
        readingDate: moment(reading.readingDate).format('DD/MM/YYYY'),
        readingAmount: (
          <Stack direction='row' gap={0.5} alignItems='center'>
            <NumericFormat
              value={reading.meterReadingAmount}
              displayType={'text'}
              thousandSeparator=","
              decimalScale={2}
              fixedDecimalScale
            />
            {reading.conversion?.measurementUnit?.name}
          </Stack>
        ),
        // emission: reading.emission && reading.emission.id ?
        // <IconButton onClick={() => navigate(``)}>
        //   <Visibility />
        // </IconButton> : null,
      }
    });

    const handleAddMeterReading = () => {
      if (selectedMeter) {
        setMeterReadingInputDialogOpen(true);
      }
    };

    const handleRefreshMeterReadings = () => {
      if (selectedMeter) {
        const reportPeriodId = reportPeriodContext.lastSelectedReportId;
        locationService.refreshMeterReadings(selectedMeter.id, reportPeriodId)
          .then(response => {
            getMeterReadings(selectedMeter.id);
            userNotificationsContext.openSnackbar({ open: true, message: `Saved successfully` });
          })
          .catch(err => {
            console.error('Error refreshing meter readings:', err);
            userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
          });
      }
    };

    const submitMeterReadingHandler = (values: IPostMeterReading, resetForm: () => void, isEdit: boolean) => {
      if (isReportPeriodLocked) {
        userNotificationsContext.openDialog({
          active: true,
          title: 'Action Not Allowed',
          message: `The selected report period is locked and cannot be modified`,
          buttonCopy: 'Ok',
          hideCancelButton: true
        })
      } else {
        if (!isEdit) {
          if (!isDialogSubmitting) {
            setIsDialogSubmitting(true)
            locationService.createMeterReading(values)
              .then(() => {
                resetForm();
                setIsDialogSubmitting(false)
                userNotificationsContext.openSnackbar({ open: true, message: `Saved successfully` });
                setMeterReadingInputDialogOpen(false);
                getMeterReadings(selectedMeter!.id);
                setSelectedMeterReadingForEdit(null);
              })
              .catch(err => {
                if (err.response.data.code === 1) {
                  userNotificationsContext.openSnackbar({ open: true, message: 'Report period is locked', backgroundColor: 'text.primary' });
                } else if (err.response.data.message) {
                  setErrorMessageMeterReading(err.response.data.message)
                } else {
                  userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
                }
                console.log(err)
                setIsDialogSubmitting(false)
              })
          }
        }
        if (isEdit && selectedMeterReadingForEdit) {
          if (!isDialogSubmitting) {
            setIsDialogSubmitting(true)
            locationService.updateMeterReading(selectedMeterReadingForEdit.id, values)
              .then(response => {
                resetForm();
                getMeterReadings(selectedMeter!.id);
                userNotificationsContext.openSnackbar({ open: true, message: `Updated successfully` });
                setIsDialogSubmitting(false)
                setMeterReadingInputDialogOpen(false);
                setSelectedMeterReadingForEdit(null);
              })
              .catch(err => {
                if (err.response.data.code === 1) {
                  userNotificationsContext.openSnackbar({ open: true, message: 'Report period is locked', backgroundColor: 'text.primary' });
                } else if (err.response.data.message) {
                  setErrorMessageMeterReading(err.response.data.message)
                } else {
                  userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
                }
                console.log(err)
                setIsDialogSubmitting(false)
              })
          }
        }
      }
    }

    const handleCloseMeterReadingInputDialog = () => {
      setMeterReadingInputDialogOpen(false);
    };


    const handleCloseMeterEditDialog = () => {
      setMeterEditDialogOpen(false);
      setSelectedMeterForEdit(null);
    };

    // const handleDeleteMeterReading = async (reading: IMeterReading) => {
    //   if (isReportPeriodLocked) {
    //     userNotificationsContext.openDialog({
    //       active: true,
    //       title: 'Action Not Allowed',
    //       message: `The selected report period is locked and cannot be modified`,
    //       buttonCopy: 'Ok',
    //       hideCancelButton: true
    //     })
    //   } else {
    //     userNotificationsContext.openDialog({
    //       active: true,
    //       title: 'Confirmation',
    //       message: `Are you sure you want to delete this meter reading? This action cannot be undone.`,
    //       buttonCopy: 'Continue',
    //       cancelButtonCopy: 'Cancel'
    //     }).then(response => {
    //       if (response) {
    //         locationService.deleteMeterReading(reading.id)
    //           .then(() => {
    //             if (selectedMeter) {
    //               getMeterReadings(selectedMeter.id);
    //             }
    //             setMetersChange(metersChange + 1);
    //           })
    //       }
    //     })
    //       .catch(err => {
    //         console.log(err)
    //         userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again.', backgroundColor: 'text.primary' });
    //       })
    //   }
    // };

    return (
      <>
        <Box sx={{ width: '100%' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'lightGrey.main' }}>
            <Tabs value={value} onChange={changeTabHandler}>
              <Tab label='General Details'  {...a11yProps(0)} />
              <Tab label='Building Details'  {...a11yProps(1)} />
              <Tab label='Utilities' {...a11yProps(2)} />
              <Tab label='Meters' {...a11yProps(3)} />
              <Tab label='Emissions' {...a11yProps(4)} />
              {newLocation.id && <Tab label='Notes' {...a11yProps(5)} />}
            </Tabs>
          </Box>
        </Box>
        <Box component='form' onSubmit={formik.handleSubmit}>
          <CustomTabPanel value={value} index={0}>
            <FormTextInputDisplay
              isTopRow={true}
              isEditPage={true}
              editField={editField}
              setEditField={setEditField}
              disabled={editField !== 'friendlyName'}
              title='Name'
              name='friendlyName'
              value={formik.values.friendlyName}
              touched={formik.touched.friendlyName}
              errors={formik.errors.friendlyName}
              onChange={formik.handleChange}
              cancelEditHandler={cancelEditHandler}
              hideEditIcon={!locationActive}
              customErrorMessage={errorCode === 1 ? errorMessage : undefined}
            />
            <FormTextInputDisplay
              isEditPage={true}
              editField={editField}
              setEditField={setEditField}
              disabled={editField !== 'locationReference'}
              title={`${screenLabelsContext.getLabel('location', { plural: false, capitalize: 'first' })} Reference`}
              name='locationReference'
              value={formik.values.locationReference}
              touched={formik.touched.locationReference}
              errors={formik.errors.locationReference}
              onChange={formik.handleChange}
              cancelEditHandler={cancelEditHandler}
              hideEditIcon={!locationActive}
              tooltip='Enter multiple references separated by commas (e.g., REF1, REF2, REF3)'
            />
            {/* <FormCheckBoxInputDisplay
              isEditPage={true}
              editField={editField}
              setEditField={setEditField}
              disabled={editField !== 'isPrimaryLocation'}
              title={`Primary ${screenLabelsContext.getLabel('location', { plural: false, capitalize: 'first' })}`}
              name='isPrimaryLocation'
              value={formik.values.isPrimaryLocation}
              touched={formik.touched.isPrimaryLocation}
              errors={formik.errors.isPrimaryLocation}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => checkboxHandler(e, 'isPrimaryLocation')}
              cancelEditHandler={cancelEditHandler}
              hideEditIcon={!locationActive}
              label={`Primary ${screenLabelsContext.getLabel('location', { plural: false, capitalize: 'first' })}`}
            /> */}
            <FormDateInputDisplay
              isEditPage={true}
              editField={editField}
              setEditField={setEditField}
              disabled={editField !== 'startDate'}
              title='Start Date'
              name='startDate'
              value={moment(formik.values.startDate)}
              touched={formik.touched.startDate}
              errors={formik.errors.startDate}
              onChange={(date: any) => dateHandler(date, 'startDate')}
              cancelEditHandler={cancelEditHandler}
              hideEditIcon={!locationActive}
              customErrorMessage={errorCode === 5 ? errorMessage : undefined}
            />
            {!locationActive &&
              <FormDateInputDisplay
                isEditPage={true}
                editField={editField}
                setEditField={setEditField}
                disabled={editField !== 'endDate'}
                title='End Date'
                name='endDate'
                value={moment(formik.values.endDate)}
                touched={formik.touched.endDate}
                errors={formik.errors.endDate}
                onChange={(date: any) => dateHandler(date, 'endDate')}
                cancelEditHandler={cancelEditHandler}
                hideEditIcon={!locationActive}
                allowEdit={false}
              />}
            <FormTextInputDisplay
              isEditPage={true}
              editField={editField}
              setEditField={setEditField}
              disabled={editField !== 'addressLineOne'}
              title='Address, Line 1'
              name='addressLineOne'
              value={formik.values.addressLineOne}
              touched={formik.touched.addressLineOne}
              errors={formik.errors.addressLineOne}
              onChange={formik.handleChange}
              cancelEditHandler={cancelEditHandler}
              hideEditIcon={!locationActive}
            />
            <FormTextInputDisplay
              isEditPage={true}
              editField={editField}
              setEditField={setEditField}
              disabled={editField !== 'addressLineTwo'}
              title='Address, Line 2'
              name='addressLineTwo'
              value={formik.values.addressLineTwo}
              touched={formik.touched.addressLineTwo}
              errors={formik.errors.addressLineTwo}
              onChange={formik.handleChange}
              cancelEditHandler={cancelEditHandler}
              hideEditIcon={!locationActive}
            />
            <FormTextInputDisplay
              isEditPage={true}
              editField={editField}
              setEditField={setEditField}
              disabled={editField !== 'city'}
              title='City'
              name='city'
              value={formik.values.city}
              touched={formik.touched.city}
              errors={formik.errors.city}
              onChange={formik.handleChange}
              cancelEditHandler={cancelEditHandler}
              hideEditIcon={!locationActive}
            />
            <FormTextInputDisplay
              isEditPage={true}
              editField={editField}
              setEditField={setEditField}
              disabled={editField !== 'postcode'}
              title='Postcode'
              name='postcode'
              value={formik.values.postcode}
              touched={formik.touched.postcode}
              errors={formik.errors.postcode}
              onChange={formik.handleChange}
              cancelEditHandler={cancelEditHandler}
              hideEditIcon={!locationActive}
            />
            {countries &&
              <FormAutoCompleteInputDisplay
                isEditPage={true}
                allowEdit={true}
                editField={editField}
                setEditField={setEditField}
                disabled={editField !== 'countryId'}
                title='Country'
                name='countryId'
                value={countries?.find(country => country.id === formik.values.countryId)}
                touched={formik.touched.countryId}
                errors={formik.errors.countryId}
                onChange={(e: any, value: ICountry | null) => selectCountryHandler(e, value)}
                cancelEditHandler={cancelEditHandler}
                hideEditIcon={!locationActive}
                options={countries.slice().sort((a, b) => (a.name === 'United Kingdom' ? -1 : b.name === 'United Kingdom' ? 1 : a.name.localeCompare(b.name)))}
                optionLabelKey={'name'}
                optionImage={'imageUrl'}
                isLastField={false}
                customErrorMessage={errorCode === 2 ? errorMessage : undefined}
                isBottomRow={false}
              />
            }
            {customFields && customFields.length > 0 && customFields.map((field) => (
              <FormTextInputDisplay
                key={field.id}
                isBottomRow={false}
                isEditPage={true}
                editField={editField}
                setEditField={setEditField}
                disabled={editField !== field.id}
                title={field.fieldName}
                name={field.id}
                type={field.fieldType === 'number' ? 'number' as const : 'text' as const}
                value={formik.values[field.id]}
                touched={formik.touched[field.id]}
                errors={formik.errors[field.id]}
                onChange={formik.handleChange}
                cancelEditHandler={cancelEditHandler}
                hideEditIcon={!locationActive}
              />
            ))
            }
            {(subsidiaries && organisation?.enableSubsidiaries) &&
              <FormSelectInputDisplay
                isEditPage={true}
                editField={editField}
                setEditField={setEditField}
                disabled={editField !== 'subsidiaryId'}
                title={`Default ${screenLabelsContext.getLabel('subsidiary', { plural: false, capitalize: 'first' })}`}
                name='subsidiaryId'
                value={formik.values.subsidiaryId}
                touched={formik.touched.subsidiaryId}
                errors={formik.errors.subsidiaryId}
                onChange={formik.handleChange}
                cancelEditHandler={cancelEditHandler}
                hideEditIcon={!locationActive}
                array={getSelectableSubsidiaries(subsidiaries, formik.values.subsidiaryId).sort((a, b) => a.name.localeCompare(b.name))}
                valueKey={'id'}
                labelKey={'name'}
              />}
            <FormSelectInputDisplay
              isEditPage={true}
              editField={editField}
              setEditField={setEditField}
              disabled={editField !== 'assignedUserId'}
              title='Default Assignee'
              name='assignedUserId'
              value={formik.values.assignedUserId}
              touched={formik.touched.assignedUserId}
              errors={formik.errors.assignedUserId}
              onChange={formik.handleChange}
              cancelEditHandler={cancelEditHandler}
              hideEditIcon={!locationActive}
              array={users.sort((a, b) => a.firstName.localeCompare(b.firstName))}
              valueKey={'id'}
              labelKey={(user) => `${user.firstName} ${user.surname}`}
              isBottomRow={true}
            />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            {buildingTypes &&
              <FormSelectInputDisplay
                isEditPage={true}
                editField={editField}
                setEditField={setEditField}
                disabled={editField !== 'buildingTypeId'}
                title='Building Type'
                name='buildingTypeId'
                value={formik.values.buildingTypeId}
                touched={formik.touched.buildingTypeId}
                errors={formik.errors.buildingTypeId}
                onChange={formik.handleChange}
                cancelEditHandler={cancelEditHandler}
                hideEditIcon={!locationActive}
                array={buildingTypes.sort((a, b) => a.name.localeCompare(b.name))}
                valueKey={'id'}
                labelKey={'name'}
                customErrorMessage={errorCode === 3 ? errorMessage : undefined}
                isTopRow={true}
              />}
            {ownership &&
              <FormSelectInputDisplay
                isEditPage={true}
                editField={editField}
                setEditField={setEditField}
                disabled={editField !== 'ownership'}
                title='Ownership'
                name='ownership'
                value={formik.values.ownership}
                touched={formik.touched.ownership}
                errors={formik.errors.ownership}
                onChange={formik.handleChange}
                cancelEditHandler={cancelEditHandler}
                hideEditIcon={!locationActive}
                array={ownership}
                allowEdit={false}
                customErrorMessage={errorCode === 4 ? errorMessage : undefined}
              />}
            <FormRadioInputDisplay
              isEditPage={true}
              allowEdit={false}
              name='hasOperationalControl'
              disabled={editField !== 'hasOperationalControl'}
              title='Control Status'
              value={formik.values.hasOperationalControl}
              touched={formik.touched.hasOperationalControl}
              errors={formik.errors.hasOperationalControl}
              onChange={controlStatusHandler}
              optionOneLabel='Operationally Controlled'
              optionOneValue={true}
              optionTwoValue={false}
              optionTwoLabel='Not Operationally Controlled'
            />
            <FormTextInputDisplay
              isEditPage={true}
              editField={editField}
              setEditField={setEditField}
              disabled={editField !== 'floorSpaceBuilding'}
              title='Building Floor Area'
              name='floorSpaceBuilding'
              value={formik.values.floorSpaceBuilding}
              touched={formik.touched.floorSpaceBuilding}
              errors={formik.errors.floorSpaceBuilding}
              onChange={formik.handleChange}
              type='number'
              cancelEditHandler={cancelEditHandler}
              hideEditIcon={!locationActive}
              tooltip='Gross internal floor area of the whole building. Used with the occupied share to work out your organisation’s floor area for leased or shared sites.'
              endAdornment={<InputAdornment position="end"><Typography variant='body2' sx={{ color: 'text.secondary' }}>sq. ft</Typography></InputAdornment>}
            />
            <FormTextInputDisplay
              isEditPage={true}
              editField={editField}
              setEditField={setEditField}
              disabled={editField !== 'occupancyRate'}
              title='Share of Building Occupied'
              name='occupancyRate'
              value={formik.values.occupancyRate}
              touched={formik.touched.occupancyRate}
              errors={formik.errors.occupancyRate}
              onChange={formik.handleChange}
              type='number'
              cancelEditHandler={cancelEditHandler}
              hideEditIcon={!locationActive}
              tooltip='The percentage of the building your organisation occupies (0-100). For leased or shared sites this apportions your share of the estimated utilities.'
              endAdornment={<InputAdornment position="end"><Typography variant='body2' sx={{ color: 'text.secondary' }}>%</Typography></InputAdornment>}
            />
            <FormTextInputDisplay
              isEditPage={true}
              editField={editField}
              setEditField={setEditField}
              allowEdit={!isOccupiedFloorAreaDerived}
              disabled={isOccupiedFloorAreaDerived || editField !== 'floorSpaceOrganisation'}
              title='Occupied Floor Area'
              name='floorSpaceOrganisation'
              value={formik.values.floorSpaceOrganisation}
              touched={formik.touched.floorSpaceOrganisation}
              errors={formik.errors.floorSpaceOrganisation}
              onChange={formik.handleChange}
              type='number'
              cancelEditHandler={cancelEditHandler}
              hideEditIcon={!locationActive || isOccupiedFloorAreaDerived}
              helperText={isOccupiedFloorAreaDerived ? 'Calculated from building floor area × share of building occupied' : 'Your organisation’s floor area, used as the basis for floor-area utility estimates'}
              tooltip='Your organisation’s floor area. This is the basis used when estimating utilities from floor area.'
              endAdornment={<InputAdornment position="end"><Typography variant='body2' sx={{ color: 'text.secondary' }}>sq. ft</Typography></InputAdornment>}
            />
            <FormTextInputDisplay
              isEditPage={true}
              editField={editField}
              setEditField={setEditField}
              disabled={editField !== 'numberOfEmployees'}
              title='Number of Employees'
              name='numberOfEmployees'
              value={formik.values.numberOfEmployees}
              touched={formik.touched.numberOfEmployees}
              errors={formik.errors.numberOfEmployees}
              onChange={formik.handleChange}
              type='number'
              cancelEditHandler={cancelEditHandler}
              hideEditIcon={!locationActive}
              isBottomRow={true}
            />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <FormCheckBoxInputDisplay
              isTopRow={true}
              isEditPage={true}
              editField={editField}
              allowEdit={showUtilities}
              isLastField={formik.values.hasElectricity === true}
              setEditField={setEditField}
              disabled={editField !== 'hasElectricity' || !showUtilities}
              title='Electricity'
              name='hasElectricity'
              value={formik.values.hasElectricity}
              touched={formik.touched.hasElectricity}
              errors={formik.errors.hasElectricity}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => checkboxHandler(e, 'hasElectricity')}
              cancelEditHandler={cancelEditHandler}
              hideEditIcon={!locationActive}
              label={'Location has Electricity'}
            />
            {formik.values.hasElectricity &&
              <>
                <FormSelectInputDisplay
                  isEditPage={true}
                  editField={editField}
                  allowEdit={showUtilities}
                  setEditField={setEditField}
                  disabled={(editField !== 'electricityBillingPeriod' && editField !== 'hasElectricity') || !showUtilities}
                  title='Billing Period'
                  forceOutlined={true}
                  topBorder={false}
                  name='electricityBillingPeriod'
                  value={formik.values.electricityBillingPeriod}
                  touched={formik.touched.electricityBillingPeriod}
                  errors={formik.errors.electricityBillingPeriod}
                  onChange={formik.handleChange}
                  cancelEditHandler={cancelEditHandler}
                  hideEditIcon={!locationActive}
                  array={Object.values(BuildingPeriod)}
                />
                {contactSuppliers &&
                  <FormAutoCompleteInputDisplay
                    isEditPage={true}
                    editField={editField}
                    forceOutlined={true}
                    topBorder={false}
                    setEditField={setEditField}
                    allowEdit={showUtilities}
                    disabled={(editField !== 'electricitySupplierId' && editField !== 'electricitySupplierName' && editField !== 'hasElectricity') || !showUtilities}
                    title={'Supplier'}
                    name='electricitySupplierId'
                    value={formik.values.electricitySupplierId ? (contactSuppliers.find(m => m.id === formik.values.electricitySupplierId) as IContactSupplierDetails | undefined) || '' : (formik.values.electricitySupplierName || '')}
                    touched={formik.touched.electricitySupplierId || formik.touched.electricitySupplierName}
                    errors={formik.errors.electricitySupplierId || formik.errors.electricitySupplierName}
                    options={[...contactSuppliers]}
                    optionLabelKey={'name'}
                    onChange={makeSupplierChangeHandler('electricity')}
                    onInputChange={makeSupplierInputChangeHandler('electricity')}
                    cancelEditHandler={cancelEditHandler}
                    freeSolo
                    virtualized
                  />}
                <Box sx={{ borderLeft: '1px solid', borderRight: '1px solid', borderColor: 'lightGrey.main' }}>
                  <Box sx={{ ml: 2 }}>
                    <ToggleButtonGroup
                      exclusive
                      size='small'
                      disabled={!showUtilities || !locationActive || (editField !== 'hasElectricity' && editField !== 'energySupplierTariffId' && editField !== 'customMarketBasedMultiplier')}
                      value={electricitySupplierMode}
                      sx={{
                        '& .MuiToggleButton-root': {
                          textTransform: 'none'
                        }
                      }}
                      onChange={handleElectricitySupplierModeChange}
                    >
                      <ToggleButton value='precreated' disabled={!showUtilities || !locationActive} sx={{ textTransform: 'none' }}>Standard Tariff</ToggleButton>
                      <ToggleButton value='own' disabled={!showUtilities || !locationActive} sx={{ textTransform: 'none' }}>Custom Tariff</ToggleButton>
                    </ToggleButtonGroup>
                  </Box>
                </Box>
                {electricitySupplierMode === 'precreated' && energySupplierTariffs && (
                  <>
                    <FormAutoCompleteInputDisplay
                      isEditPage={true}
                      editField={editField}
                      allowEdit={showUtilities}
                      setEditField={setEditField}
                      disabled={(editField !== 'energySupplierTariffId' && editField !== 'energySupplierTariffName' && editField !== 'hasElectricity') || !showUtilities}
                      title='Tariff'
                      forceOutlined={true}
                      topBorder={false}
                      name='energySupplierTariffId'
                      value={energySupplierTariffs?.find(tariff => tariff.id === formik.values.energySupplierTariffId) || null}
                      touched={formik.touched.energySupplierTariffId}
                      errors={formik.errors.energySupplierTariffId}
                      onChange={(e: any, value: IEnergySupplierTariff | null) => {
                        handlePreCreatedTariffChange(value?.id || '');
                      }}
                      cancelEditHandler={cancelEditHandler}
                      hideEditIcon={!locationActive}
                      options={energySupplierTariffs.slice().sort((a, b) => {
                        const supplierCompare = a.energySupplier.name.localeCompare(b.energySupplier.name);
                        if (supplierCompare !== 0) return supplierCompare;
                        return a.name.localeCompare(b.name);
                      })}
                      optionLabelKey={'name'}
                      groupBy={(option: IEnergySupplierTariff) => option.energySupplier.name}
                      getOptionLabel={(option: IEnergySupplierTariff) => `${option.name} (${option.energySupplier.name})`}
                    />
                  </>
                )}
                {electricitySupplierMode === 'own' && (
                  <FormTextInputDisplay
                    isEditPage={true}
                    editField={editField}
                    topBorder={false}
                    allowEdit={showUtilities}
                    setEditField={setEditField}
                    disabled={(editField !== 'customMarketBasedMultiplier' && editField !== 'hasElectricity' && editField !== 'energySupplierTariffId' && editField !== 'electricitySupplierId' && editField !== 'electricitySupplierName') || !showUtilities}
                    forceOutlined={true}
                    title='Supplier Emission Rate'
                    name='customMarketBasedMultiplier'
                    value={formik.values.customMarketBasedMultiplier}
                    touched={formik.touched.customMarketBasedMultiplier}
                    errors={formik.errors.customMarketBasedMultiplier}
                    onChange={formik.handleChange}
                    cancelEditHandler={cancelEditHandler}
                    hideEditIcon={!locationActive}
                    endAdornment={<InputAdornment position="end"><Typography variant='body2' sx={{ color: 'text.secondary' }}>kgCO₂/kWh</Typography></InputAdornment>}
                  />)}
              </>}
            <FormCheckBoxInputDisplay
              isEditPage={true}
              editField={editField}
              setEditField={setEditField}
              allowEdit={showUtilities}
              disabled={editField !== 'hasGas' || !showUtilities}
              title='Gas'
              name='hasGas'
              isLastField={formik.values.hasGas === true}
              value={formik.values.hasGas}
              touched={formik.touched.hasGas}
              errors={formik.errors.hasGas}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => checkboxHandler(e, 'hasGas')}
              cancelEditHandler={cancelEditHandler}
              hideEditIcon={!locationActive}
              label={'Location has Gas'}
            />
            {formik.values.hasGas &&
              <>
                <FormSelectInputDisplay
                  isEditPage={true}
                  editField={editField}
                  allowEdit={showUtilities}
                  setEditField={setEditField}
                  disabled={(editField !== 'gasBillingPeriod' && editField !== 'hasGas') || !showUtilities}
                  title='Billing Period'
                  forceOutlined={true}
                  name='gasBillingPeriod'
                  value={formik.values.gasBillingPeriod}
                  touched={formik.touched.gasBillingPeriod}
                  errors={formik.errors.gasBillingPeriod}
                  onChange={formik.handleChange}
                  cancelEditHandler={cancelEditHandler}
                  hideEditIcon={!locationActive}
                  topBorder={false}
                  array={Object.values(BuildingPeriod)}
                />
                {contactSuppliers &&
                  <FormAutoCompleteInputDisplay
                    isEditPage={true}
                    editField={editField}
                    setEditField={setEditField}
                    allowEdit={showUtilities}
                    forceOutlined={true}
                    topBorder={false}
                    disabled={(editField !== 'gasSupplierId' && editField !== 'hasGas') || !showUtilities}
                    title={'Supplier'}
                    name='gasSupplierId'
                    value={formik.values.gasSupplierId ? (contactSuppliers.find(m => m.id === formik.values.gasSupplierId) as IContactSupplierDetails | undefined) || '' : (formik.values.gasSupplierName || '')}
                    touched={formik.touched.gasSupplierId || formik.touched.gasSupplierName}
                    errors={formik.errors.gasSupplierId || formik.errors.gasSupplierName}
                    options={[...contactSuppliers]}
                    optionLabelKey={'name'}
                    onChange={makeSupplierChangeHandler('gas')}
                    onInputChange={makeSupplierInputChangeHandler('gas')}
                    cancelEditHandler={cancelEditHandler}
                    freeSolo
                    virtualized
                  />}
              </>}
            <FormCheckBoxInputDisplay
              isEditPage={true}
              editField={editField}
              setEditField={setEditField}
              allowEdit={showUtilities}
              isLastField={formik.values.hasAirCon === true}
              disabled={editField !== 'hasAirCon' || !showUtilities}
              title='Air Conditioning'
              name='hasAirCon'
              value={formik.values.hasAirCon}
              touched={formik.touched.hasAirCon}
              errors={formik.errors.hasAirCon}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => checkboxHandler(e, 'hasAirCon')}
              cancelEditHandler={cancelEditHandler}
              hideEditIcon={!locationActive}
              label={'Location has Air Conditioning'}
            />
            {formik.values.hasAirCon &&
              <>
                <FormSelectInputDisplay
                  isEditPage={true}
                  allowEdit={showUtilities}
                  editField={editField}
                  setEditField={setEditField}
                  disabled={(editField !== 'airConBillingPeriod' && editField !== 'hasAirCon') || !showUtilities}
                  title='Billing Period'
                  forceOutlined={true}
                  name='airConBillingPeriod'
                  value={formik.values.airConBillingPeriod}
                  touched={formik.touched.airConBillingPeriod}
                  errors={formik.errors.airConBillingPeriod}
                  onChange={formik.handleChange}
                  cancelEditHandler={cancelEditHandler}
                  hideEditIcon={!locationActive}
                  topBorder={false}
                  array={Object.values(BuildingPeriod)}
                />
                {contactSuppliers &&
                  <FormAutoCompleteInputDisplay
                    isEditPage={true}
                    forceOutlined={true}
                    editField={editField}
                    topBorder={false}
                    setEditField={setEditField}
                    allowEdit={showUtilities}
                    disabled={(editField !== 'airConSupplierId' && editField !== 'hasAirCon') || !showUtilities}
                    title={'Supplier'}
                    name='airConSupplierId'
                    value={formik.values.airConSupplierId ? (contactSuppliers.find(m => m.id === formik.values.airConSupplierId) as IContactSupplierDetails | undefined) || '' : (formik.values.airConSupplierName || '')}
                    touched={formik.touched.airConSupplierId || formik.touched.airConSupplierName}
                    errors={formik.errors.airConSupplierId || formik.errors.airConSupplierName}
                    options={[...contactSuppliers]}
                    optionLabelKey={'name'}
                    onChange={makeSupplierChangeHandler('airCon')}
                    onInputChange={makeSupplierInputChangeHandler('airCon')}
                    cancelEditHandler={cancelEditHandler}
                    freeSolo
                    virtualized
                  />}
              </>}
            <FormCheckBoxInputDisplay
              isEditPage={true}
              editField={editField}
              setEditField={setEditField}
              allowEdit={showUtilities}
              disabled={editField !== 'hasSteam' || !showUtilities}
              title='Heat and Steam'
              name='hasSteam'
              value={formik.values.hasSteam}
              touched={formik.touched.hasSteam}
              errors={formik.errors.hasSteam}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => checkboxHandler(e, 'hasSteam')}
              cancelEditHandler={cancelEditHandler}
              hideEditIcon={!locationActive}
              label={'Location has Heat and Steam'}
            />
            {formik.values.hasSteam &&
              <>
                <FormSelectInputDisplay
                  allowEdit={showUtilities}
                  isEditPage={true}
                  editField={editField}
                  setEditField={setEditField}
                  disabled={(editField !== 'heatAndSteamBillingPeriod' && editField !== 'hasSteam') || !showUtilities}
                  title='Billing Period'
                  forceOutlined={true}
                  name='heatAndSteamBillingPeriod'
                  value={formik.values.heatAndSteamBillingPeriod}
                  touched={formik.touched.heatAndSteamBillingPeriod}
                  errors={formik.errors.heatAndSteamBillingPeriod}
                  onChange={formik.handleChange}
                  cancelEditHandler={cancelEditHandler}
                  hideEditIcon={!locationActive}
                  array={Object.values(BuildingPeriod)}
                  topBorder={false}
                />
                {contactSuppliers &&
                  <FormAutoCompleteInputDisplay
                    isEditPage={true}
                    editField={editField}
                    setEditField={setEditField}
                    topBorder={false}
                    forceOutlined={true}
                    allowEdit={showUtilities}
                    disabled={(editField !== 'heatAndSteamSupplierId' && editField !== 'hasSteam') || !showUtilities}
                    title={'Supplier'}
                    name='heatAndSteamSupplierId'
                    value={formik.values.heatAndSteamSupplierId ? (contactSuppliers.find(m => m.id === formik.values.heatAndSteamSupplierId) as IContactSupplierDetails | undefined) || '' : (formik.values.heatAndSteamSupplierName || '')}
                    touched={formik.touched.heatAndSteamSupplierId || formik.touched.heatAndSteamSupplierName}
                    errors={formik.errors.heatAndSteamSupplierId || formik.errors.heatAndSteamSupplierName}
                    options={[...contactSuppliers]}
                    optionLabelKey={'name'}
                    onChange={makeSupplierChangeHandler('heatAndSteam')}
                    onInputChange={makeSupplierInputChangeHandler('heatAndSteam')}
                    cancelEditHandler={cancelEditHandler}
                    freeSolo
                    virtualized
                  />}
              </>}
            <FormCheckBoxInputDisplay
              isEditPage={true}
              editField={editField}
              setEditField={setEditField}
              allowEdit={showUtilities}
              isLastField={formik.values.hasWater === true}
              disabled={editField !== 'hasWater' || !showUtilities}
              title='Water'
              name='hasWater'
              value={formik.values.hasWater}
              touched={formik.touched.hasWater}
              errors={formik.errors.hasWater}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => checkboxHandler(e, 'hasWater')}
              cancelEditHandler={cancelEditHandler}
              hideEditIcon={!locationActive}
              label={'Location has mains Water'}
            />
            {formik.values.hasWater &&
              <FormSelectInputDisplay
                isEditPage={true}
                editField={editField}
                allowEdit={showUtilities}
                setEditField={setEditField}
                disabled={(editField !== 'waterBillingPeriod' && editField !== 'hasWater') || !showUtilities}
                title='Billing Period'
                forceOutlined={true}
                name='waterBillingPeriod'
                value={formik.values.waterBillingPeriod}
                touched={formik.touched.waterBillingPeriod}
                errors={formik.errors.waterBillingPeriod}
                onChange={formik.handleChange}
                cancelEditHandler={cancelEditHandler}
                hideEditIcon={!locationActive}
                topBorder={false}
                array={Object.values(BuildingPeriod)}
              />}
            <FormCheckBoxInputDisplay
              isEditPage={true}
              editField={editField}
              setEditField={setEditField}
              allowEdit={showUtilities}
              isLastField={formik.values.hasWaste === true}
              disabled={editField !== 'hasWaste' || !showUtilities}
              title='Waste'
              name='hasWaste'
              value={formik.values.hasWaste}
              touched={formik.touched.hasWaste}
              errors={formik.errors.hasWaste}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => checkboxHandler(e, 'hasWaste')}
              cancelEditHandler={cancelEditHandler}
              hideEditIcon={!locationActive}
              label={'Location has Waste collection'}
              isBottomRow={formik.values.hasWaste ? false : true}
            />
            {formik.values.hasWaste &&
              <FormSelectInputDisplay
                isEditPage={true}
                editField={editField}
                allowEdit={showUtilities}
                setEditField={setEditField}
                disabled={(editField !== 'wasteBillingPeriod' && editField !== 'hasWaste') || !showUtilities}
                title='Collection Period'
                forceOutlined={true}
                name='wasteBillingPeriod'
                value={formik.values.wasteBillingPeriod}
                touched={formik.touched.wasteBillingPeriod}
                errors={formik.errors.wasteBillingPeriod}
                onChange={formik.handleChange}
                cancelEditHandler={cancelEditHandler}
                hideEditIcon={!locationActive}
                topBorder={false}
                isBottomRow={true}
                array={Object.values(BuildingPeriod)}
              />}
          </CustomTabPanel >
          <CustomTabPanel value={value} index={3}>
            {!showMeterReadings ? (
              <>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', mb: 1 }}>
                  {isGaiaUser &&
                    //Only compatiable with Electricity 
                    <Button
                      sx={{ mr: 2 }}
                      variant="contained"
                      onClick={handleSearchMeter}
                      disabled={!locationActive}>
                      <Search sx={{ mr: '4px' }} />
                      <Typography>Search for Meter</Typography>
                    </Button>}
                  <Button
                    variant="text"
                    onClick={() => setMeterInputDialogOpen(true)}
                    disabled={!locationActive}>
                    <Add />
                    <Typography>Add Meter</Typography>
                  </Button>
                </Box>
                <LoadingPage pageReady={!isMetersLoading}>
                  {(meters && meters.length > 0) ? (
                    <TableDisplay
                      isEmissionMobile={false}
                      onOrderChange={handleMetersOrderChange}
                      isMobileMode={isMobileMode}
                      headCells={metersHeadCells}
                      rows={metersRows}
                      selected={metersSelected}
                      setSelected={setMetersSelected}
                      selectByIcon={true}
                      inputPage={metersInputPage}
                      setInputPage={setMetersInputPage}
                      totalRecords={metersTotalRecords}
                      perPage={metersPerPage}
                      setPerPage={setMetersPerPage}
                      handleSelected={handleMetersSelected} />
                  ) : (
                    <InformationBox
                      text={`There are no meters for this ${screenLabelsContext.getLabel('location', { plural: false })}`}
                      icon={IconName.CheckCircleOutlined}
                    />
                  )}
                </LoadingPage>
              </>
            ) : (
              <>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                  <BackButtonLink buttonText='Back to meters' onClick={handleBackToMeters} />
                  {hasOpenReport && !isReportPeriodLocked && <>
                    <Button
                      variant="text"
                      onClick={selectedMeter?.source === 'PERSE' ? handleRefreshMeterReadings : handleAddMeterReading}
                      disabled={!locationActive || !selectedMeter}
                    >
                      {selectedMeter?.source === 'PERSE' ? <Refresh /> : <Add />}
                      <Typography>
                        {selectedMeter?.source === 'PERSE' ? 'Refresh Readings' : 'Add Meter Reading'}
                      </Typography>
                    </Button>
                  </>

                  }
                </Box>
                <LoadingPage pageReady={!isReadingsLoading}>
                  <Typography variant='h5' sx={{ mb: 1 }}>Meter:{selectedMeter?.name}</Typography>
                  {meterReadings.length > 0 ? (
                    <TableDisplay
                      isEmissionMobile={false}
                      onOrderChange={() => { }}
                      isMobileMode={isMobileMode}
                      headCells={readingsHeadCells}
                      rows={readingsRows}
                      selected={[]}
                      setSelected={() => { }}
                      selectByIcon={true}
                      inputPage={0}
                      setInputPage={() => { }}
                      totalRecords={meterReadings.length}
                      perPage={10}
                      setPerPage={() => { }}
                      handleSelected={() => { }} />
                  ) : (
                    <InformationBox
                      text='There are no readings for this meter'
                      icon={IconName.CheckCircleOutlined}
                    />
                  )}
                </LoadingPage>
              </>
            )}
          </CustomTabPanel >
          <CustomTabPanel value={value} index={4}>
            {!hasOpenReport &&
              <Box>
                < ClosedReportPeriodMessage openDialog={() => { setDialogOpen(true) }} />
                {dialogOpen && <StartNewReportPeriodDialog open={dialogOpen} closeHandler={() => { setDialogOpen(false) }} />}
              </Box>}
            {hasOpenReport && <LoadingPage pageReady={!isLoading}>
              {reportPeriodContext.lastSelectedReportId && newLocation.id && (
                <Emissions
                  queryString={`&locationId=${newLocation.id}`}
                  backLink={`/organisation/locations/${newLocation.id}?tabId=4`}
                  backText='Back to location'
                />
              )}
            </LoadingPage>}
          </CustomTabPanel >
        </Box >
        {/* Outside the form: the composer's buttons and Enter key must never submit the location. */}
        {newLocation.id && (
          <CustomTabPanel value={value} index={5}>
            <NotesPanel
              relatedModelName='location'
              relatedObjectId={newLocation.id}
              canWrite={canWriteNotes}
              periodOptions={notePeriodOptions}
            />
          </CustomTabPanel>
        )}
        {!selectedMeterForEdit && meterInputDialogOpen &&
          <MeterInputDialog
            isEdit={false}
            open={meterInputDialogOpen}
            onClose={handleCloseMeterInputDialog}
            onSubmit={submitMeterHandler}
            locationId={newLocation.id}
            subsidiaryId={formik.values.subsidiaryId}
            isSubmitting={false}
            errorMessage={errorMessageMeter}
          />}
        {selectedMeterForEdit && meterEditDialogOpen &&
          <MeterInputDialog
            isEdit={true}
            locationId={newLocation.id}
            open={meterEditDialogOpen}
            onClose={handleCloseMeterEditDialog}
            onSubmit={submitMeterHandler}
            meter={selectedMeterForEdit}
            subsidiaryId={formik.values.subsidiaryId}
            isSubmitting={false}
            errorMessage={errorMessageMeter}
          />}
        {meterReadingInputDialogOpen && !selectedMeterReadingForEdit &&
          <MeterReadingInputDialog
            isEdit={false}
            open={meterReadingInputDialogOpen && !!selectedMeter}
            onClose={handleCloseMeterReadingInputDialog}
            onSubmit={submitMeterReadingHandler}
            meterId={selectedMeter?.id || ''}
            meterName={selectedMeter?.name || ''}
            units={selectedMeter?.conversion?.measurementUnit?.name || ''}
            errorMessage={errorMessageMeterReading}
            mostRecentReadingDate={meterReadings.length > 0 ? meterReadings[0].readingDate : null}
            mostRecentReadingAmount={meterReadings.length > 0 ? meterReadings[0].meterReadingAmount : null}
            isSubmitting={false}
          />}
        {selectedMeterReadingForEdit && meterReadingInputDialogOpen &&
          <MeterReadingInputDialog
            isEdit={true}
            open={meterReadingInputDialogOpen && !!selectedMeter}
            onClose={handleCloseMeterReadingInputDialog}
            onSubmit={submitMeterReadingHandler}
            meterId={selectedMeter?.id || ''}
            reading={selectedMeterReadingForEdit}
            meterName={selectedMeter?.name || ''}
            units={selectedMeter?.conversion?.measurementUnit?.name || ''}
            errorMessage={errorMessageMeterReading}
            isSubmitting={false}
          />}
        {meterSearchDialogOpen &&
          <MeterPostcodeDialog
            open={meterSearchDialogOpen}
            onClose={() => setMeterSearchDialogOpen(false)}
            searchPostcode={searchPostcode}
            onPostcodeChange={setSearchPostcode}
            onSearch={handleSearchMeterWithPostcode}
          />}
        {addressSelectionDialogOpen &&
          <AddressSelectionDialog
            open={addressSelectionDialogOpen}
            onClose={() => setAddressSelectionDialogOpen(false)}
            searchResults={searchResults}
            selectedAddressId={selectedAddressId}
            onAddressChange={setSelectedAddressId}
            onConfirm={handleAddressSelection}
            existingMeters={meters}
            locationId={newLocation.id}
          />}
      </>
    )
  }